import React from "react";
import "./index.scss";
import { CheckOutlined, ExclamationCircleFilled, SaveOutlined } from "@ant-design/icons";
import AuthZButton from "../AuthzButton";
import { IsFeatureEnabledOrNot } from "../../FeatureToggles/FeatureEnabledOrNot";
import { ToggleList } from "../../FeatureToggles/toggleList";
import { Tooltip } from "antd";

export const SubmitBoard = ({
                              id,
                              show,
                              submitDisabled,
                              onSubmitBtnClick,
                              saveDisabled,
                              onSaveBtnClick,
                              saveDisabledReason,
                              getPopupContainer,
                            }) => {
  const isSaveAsDraftFeatureEnabled = IsFeatureEnabledOrNot(ToggleList.SaveAsDraft);
  const popOverContent = (
    <div>
      <p className={"submit-board-text"}>
        Please note that the changes you make will not be saved automatically.
        <br />
        1. You need to submit the changes where the access needs to be removed or adjusted. Once
        submitted, the changes will be sent to the Gits team.
        <br />
        2. You can come back and finish the rest before the review is closed.
      </p>
    </div>
  );
  const renderPopOver = () => (
    <Tooltip
      title={popOverContent}
      trigger="hover"
      placement="leftTop"
      getPopupContainer={getPopupContainer}
    >
      <ExclamationCircleFilled style={{ color: "grey" }} />
    </Tooltip>
  );

  function renderSaveForLaterButton() {
    if (isSaveAsDraftFeatureEnabled) {
      return (
        <div className="save-for-later-container">
          <AuthZButton
            authZButtonType="default"
            buttonDisabled={saveDisabled}
            onClick={onSaveBtnClick}
            icon={<SaveOutlined />}
            tooltipTitle={saveDisabledReason}
            getPopupContainer={getPopupContainer}
          >
            Save for later
          </AuthZButton>
          {renderPopOver()}
        </div>
      );
    }
    return null;
  }

  return (
    show && (
      <div id={id} className={"submit-board-background"}>
        <div className={"submit-board-buttons"}>
          {renderSaveForLaterButton()}
          <div className="preview-and-submit-button">
            <AuthZButton
              authZButtonType="primary"
              buttonDisabled={submitDisabled}
              onClick={onSubmitBtnClick}
              icon={<CheckOutlined />}
              getPopupContainer={(triggerNode) => triggerNode}
            >
              Preview and Submit
            </AuthZButton>
          </div>
        </div>
      </div>
    )
  );
};
